import React, { useEffect, useState } from "react";
import Banner from "../../../Components/Common/Banner";
import CareerImg from "../../../Assets/images/BannerImages/Career.png";
import { useNavigate } from "react-router-dom";
import CompetitiveSalary from "../../../Assets/images/Career/CompetitiveSalary.png";
import ProfessionalDevelopment from "../../../Assets/images/Career/ProfessionalDevelopment.png";
import NetworkingOpportunities from "../../../Assets/images/Career/NetworkingOpportunities.png";
import Mentorship from "../../../Assets/images/Career/Mentorship&Leadership.png";
import career_bg_2_color from "../../../Assets/images/Career/career_bg_2_color.png";
import career_image from "../../../Assets/images/Career/career_image.png";
import { CiCalendar, CiLocationOn } from "react-icons/ci";
import { IoIosArrowBack, IoIosArrowForward, IoMdTimer } from "react-icons/io";
import { RiMoneyDollarCircleLine } from "react-icons/ri";
import GetInTouchUs from "../../../Components/Common/GetInTouchUs";
import axios from "axios";

const Career = () => {
  const navigate = useNavigate();
  const [jobData, setJobData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const [filters, setFilters] = useState({
    employmentType: [],
    salary: "",
    skills: [],
  });

  console.log(filters);

  const handleFilterChange = (filterType, value) => {
    if (filterType === "skills") {
      const updatedSkills = filters.skills.includes(value)
        ? filters.skills.filter((skill) => skill !== value)
        : [...filters.skills, value];
      setFilters({ ...filters, [filterType]: updatedSkills });
    } else if (filterType === "salary") {
      if (filters.salary === value) {
        // If the same filter value is clicked again, reset the salary filter
        setFilters({ ...filters, salary: "" });
      } else {
        // Toggle between ascending and descending order
        setFilters({ ...filters, salary: value });
      }
    } else if (filterType === "employmentType") {
      // Toggle employment type selection
      const updatedEmploymentTypes = filters.employmentType.includes(value)
        ? filters.employmentType.filter((type) => type !== value)
        : [...filters.employmentType, value];
      setFilters({ ...filters, [filterType]: updatedEmploymentTypes });
    } else {
      // Handle other filter types
      setFilters({ ...filters, [filterType]: value });
    }
  };

  // Function to clear all filters
  const clearFilters = () => {
    setFilters({
      employmentType: [],
      salary: "",
      skills: [],
    });
  };

  const filteredJobs = jobData
    .filter((job) => {
      const matchesEmploymentType =
        filters.employmentType.length === 0 ||
        filters.employmentType.includes(job.job_type);
      const matchesSkills =
        filters.skills.length === 0 ||
        filters.skills.some((skill) => job.skills.includes(skill));

      return matchesEmploymentType && matchesSkills;
    })
    .sort((a, b) => {
      if (filters.salary === "asc") {
        return parseFloat(a.salary) - parseFloat(b.salary);
      } else if (filters.salary === "desc") {
        return parseFloat(b.salary) - parseFloat(a.salary);
      } else {
        return 0;
      }
    });

  const navigateToDetail = (post) => {
    console.log(post);

    const titleWithDashes = post.job_title.replace(/\s+/g, "-"); // Replace spaces with dashes
    navigate(`/contact-us/career/${encodeURIComponent(titleWithDashes)}`, {
      state: { post },
    });
  };

  const getAllJobOpenings = () => {
    let data = "";

    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_BASE_URL}/job-openings/get-all-openings`,
      headers: {},
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(response.data);
        setJobData(response?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getAllJobOpenings();
  }, []);

  function getTimeAgo(dateString) {
    const date = new Date(dateString);
    const currentDate = new Date();

    const timeDifference = currentDate - date;

    // Convert milliseconds to appropriate units
    const seconds = Math.floor(timeDifference / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const months = Math.floor(days / 30);
    const years = Math.floor(months / 12);

    if (seconds < 60) {
      return `${seconds} second${seconds !== 1 ? "s" : ""} ago`;
    } else if (minutes < 60) {
      return `${minutes} minute${minutes !== 1 ? "s" : ""} ago`;
    } else if (hours < 24) {
      return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
    } else if (days < 30) {
      return `${days} day${days !== 1 ? "s" : ""} ago`;
    } else if (months < 12) {
      return `${months} month${months !== 1 ? "s" : ""} ago`;
    } else {
      return `${years} year${years !== 1 ? "s" : ""} ago`;
    }
  }

  const startIndex = (currentPage - 1) * itemsPerPage;
  const totalPages = Math.ceil(filteredJobs.length / itemsPerPage);

  const paginatedJobs = filteredJobs.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const nextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  const prevPage = () => {
    setCurrentPage(currentPage - 1);
  };

  const goToPage = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="bg-white">
      <Banner
        pageName="CAREER"
        breadcrummbs="Home / Contact Us / Career"
        bgimage={CareerImg}
      />
      <div className="lg:px-20 md:px-10 px-5 py-10">
        <div className="grid lg:grid-cols-2 grid-cols-1">
          <h1 className="tracking-wider font-bold lg:text-4xl md:text-3xl text-2xl lg:w-[70%] ">
            Transform Your Skills br with Our Courses
          </h1>
          <p className="tracking-wider text-secondaryTextColor">
            Gain practical knowledge and industry-relevant expertise through our expertly designed courses to accelerate your career growth.
          </p>
        </div>

        <div className="grid lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-4 my-10">
          <div className="border px-4 py-4 flex flex-col gap-4 bg-[#D4E6FF] rounded">
            <img
              src={CompetitiveSalary}
              alt="Competitive Salary Icon"
              className="w-12"
            />
            <p className="font-bold md:w-[40%]">Competitive Salary</p>
          </div>
          <div className="border px-4 py-4 flex flex-col gap-4 bg-[#D4E6FF] rounded">
            <img
              src={ProfessionalDevelopment}
              alt="Competitive Salary Icon"
              className="w-12"
            />
            <p className="font-bold md:w-[40%]">Professional Development</p>
          </div>
          <div className="border px-4 py-4 flex flex-col gap-4 bg-[#D4E6FF] rounded">
            <img
              src={NetworkingOpportunities}
              alt="Competitive Salary Icon"
              className="w-12"
            />
            <p className="font-bold md:w-[40%]">Networking Opportunities</p>
          </div>
          <div className="border px-4 py-4 flex flex-col gap-4 bg-[#D4E6FF] rounded">
            <img
              src={Mentorship}
              alt="Competitive Salary Icon"
              className="w-12"
            />
            <p className="font-bold md:w-[40%]">Mentorship & Leadership</p>
          </div>
        </div>

        <div className="mb-8">
          <h1 className="lg:text-4xl md:text-3xl text-2xl text-center font-medium">
            Check Out Our{" "}
            <span className="text-primaryDarkColor">Current Job</span> Openings.
          </h1>
          <p className="text-secondaryTextColor mt-2 lg:w-[70%] text-center m-auto tracking-wider">
            Join our dynamic team and be part of innovative projects that shape the future of technology and business.
          </p>
        </div>

        <div className="flex lg:flex-row flex-col  gap-4 ">
          <div className="border w-[20%] lg:flex lg:flex-col hidden p-4">
            <div className="flex justify-between">
              <h2 className="font-medium text-lg">Filters</h2>
              <button
                onClick={() => clearFilters()}
                className={`px-4 py-1 rounded-md ${
                  filters.employmentType.length === 0 &&
                  filters.salary === "" &&
                  filters.skills.length === 0
                    ? "bg-gray-300 text-gray-600"
                    : "bg-blue-500 text-white"
                }`}
              >
                Clear
              </button>
            </div>

            {/* Type of employment */}
            <div className="mt-4">
              <p className="font-medium mb-2">Type of employment</p>
              <div className="flex flex-col gap-2">
                <div className="flex flex-col gap-2">
                  <div className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      id="fullTime"
                      name="employmentType"
                      checked={filters.employmentType.includes("Full-Time")}
                      onChange={() =>
                        handleFilterChange("employmentType", "Full-Time")
                      }
                    />
                    <label htmlFor="fullTime">Full-Time</label>
                  </div>
                  <div className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      id="workRemotely"
                      name="employmentType"
                      checked={filters.employmentType.includes("Work Remotely")}
                      onChange={() =>
                        handleFilterChange("employmentType", "Work Remotely")
                      }
                    />
                    <label htmlFor="workRemotely">Work Remotely</label>
                  </div>
                  <div className="flex items-center gap-2">
                    <input
                      type="checkbox"
                      id="partTime"
                      name="employmentType"
                      checked={filters.employmentType.includes("Part-Time")}
                      onChange={() =>
                        handleFilterChange("employmentType", "Part-Time")
                      }
                    />
                    <label htmlFor="partTime">Part-Time</label>
                  </div>
                </div>
              </div>
            </div>

            {/* Salary */}
            <div className="mt-4">
              <p className="font-medium mb-2">Salary</p>
              <div className="flex flex-col gap-2">
                <div className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    id="salaryAsc"
                    name="salary"
                    checked={filters.salary === "asc"}
                    onChange={() => handleFilterChange("salary", "asc")}
                  />
                  <label htmlFor="salaryAsc">Low to High</label>
                </div>
                <div className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    id="salaryDesc"
                    name="salary"
                    checked={filters.salary === "desc"}
                    onChange={() => handleFilterChange("salary", "desc")}
                  />
                  <label htmlFor="salaryDesc">High to Low</label>
                </div>
              </div>
            </div>

            {/* Skills */}
            <div className="mt-4">
              <p className="font-medium mb-2">Skills</p>
              <div className="flex flex-col gap-2">
                <div className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    id="htmlSkill"
                    name="skills"
                    checked={filters.skills.includes("HTML")}
                    onChange={() => handleFilterChange("skills", "HTML")}
                  />
                  <label htmlFor="htmlSkill">HTML</label>
                </div>
                <div className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    id="cssSkill"
                    name="skills"
                    checked={filters.skills.includes("CSS")}
                    onChange={() => handleFilterChange("skills", "CSS")}
                  />
                  <label htmlFor="cssSkill">CSS</label>
                </div>
                <div className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    id="javascriptSkill"
                    name="skills"
                    checked={filters.skills.includes("JavaScript")}
                    onChange={() => handleFilterChange("skills", "JavaScript")}
                  />
                  <label htmlFor="javascriptSkill">Java Script</label>
                </div>
                <div className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    id="expressjsSkill"
                    name="skills"
                    checked={filters.skills.includes("Express.js")}
                    onChange={() => handleFilterChange("skills", "Express.js")}
                  />
                  <label htmlFor="expressjsSkill">Express.Js</label>
                </div>
                <div className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    id="nodejsSkill"
                    name="skills"
                    checked={filters.skills.includes("Node.js")}
                    onChange={() => handleFilterChange("skills", "Node.js")}
                  />
                  <label htmlFor="nodejsSkill">Node.Js</label>
                </div>
                <div className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    id="reactSkill"
                    name="skills"
                    checked={filters.skills.includes("React")}
                    onChange={() => handleFilterChange("skills", "React")}
                  />
                  <label htmlFor="reactSkill">React</label>
                </div>
              </div>
            </div>
          </div>
          <div className="h-auto lg:w-[80%] flex flex-col gap-4">
            {paginatedJobs?.map((post) => (
              <div
                key={post.id}
                onClick={() => navigateToDetail(post)}
                className="flex lg:flex-row flex-col gap-2 p-4 border rounded cursor-pointer shadow-md"
              >
                <div className="w-[15%]">
                  <img
                    src="https://i.pinimg.com/236x/df/d9/20/dfd920d66018e05f9db01321ec1fb5aa.jpg"
                    alt="Logo"
                    className="w-[80%] border rounded-lg"
                  />
                </div>
                <div className="lg:w-[90%] flex flex-col gap-2">
                  <p className="font-medium">{post?.company_name}</p>
                  <h1 className="font-bold text-lg">{post.job_title}</h1>
                  <div className="flex flex-wrap gap-2 justify-between">
                    <div className="flex items-center text-secondaryTextColor gap-1">
                      <CiLocationOn />
                      <p className="text-sm">{post.job_location}</p>
                    </div>
                    <div className="flex items-center text-secondaryTextColor gap-1">
                      <IoMdTimer />
                      <p className="text-sm">{post.job_type}</p>
                    </div>
                    <div className="flex items-center text-secondaryTextColor gap-1">
                      <RiMoneyDollarCircleLine />
                      <p className="text-sm">{post.salary} month</p>
                    </div>
                    <div className="flex items-center text-secondaryTextColor gap-1">
                      <CiCalendar />
                      <p className="text-sm">
                        {getTimeAgo(post.posted_date_time)}
                      </p>
                    </div>
                  </div>
                  <p className="text-secondaryTextColor tracking-wide text-justify">
                    {post.job_long_description}
                  </p>
                </div>
              </div>
            ))}

            <div className="flex justify-end mt-6">
              <div className="flex items-center gap-2">
                <div
                  className={`border px-3 h-full flex items-center cursor-pointer ${
                    currentPage === 1 ? "opacity-50 pointer-events-none" : ""
                  }`}
                  onClick={prevPage}
                >
                  <IoIosArrowBack />
                </div>
                <div className="flex gap-2">
                  {[...Array(totalPages).keys()].map((page) => (
                    <button
                      key={page}
                      className={`border px-4 py-2 hover:bg-blue-500 ${
                        currentPage === page + 1 ? "bg-blue-500 text-white" : ""
                      }`}
                      onClick={() => goToPage(page + 1)}
                    >
                      {page + 1}
                    </button>
                  ))}
                </div>
                <div
                  className={`border px-3 h-full flex items-center cursor-pointer ${
                    currentPage === totalPages
                      ? "opacity-50 pointer-events-none"
                      : ""
                  }`}
                  onClick={nextPage}
                >
                  <IoIosArrowForward />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="">
        <div
          style={{
            backgroundImage: `url(${career_bg_2_color})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
          className="lg:px-20 md:px-10 px-5 pb-10"
        >
          <img
            src={career_image}
            alt="career image"
            className="w-full m-auto"
          />
        </div>
        <div className=" bg-[#7B96BD] lg:px-20 md:px-10 px-5 pb-10 text-white tracking-wider">
          <div className="flex lg:flex-row flex-col gap-4 ">
            <div className="lg:w-[40%]">
              <h1 className="lg:text-4xl md:text-3xl text-xl lg:w-[80%] font-bold">
                Join the Techmentee Family !
              </h1>
            </div>
            <div className="lg:w-[60%]">
              <p>
                The staffing world can too often be reduced to a numbers game
                but to us, the taste of success does not only in getting
                placements instead what we look for is Veracity and that is only
                possible when we could find the right fit for both our candidate
                and our client.And the idea of getting the “Right Fit” has
                always been the aim of our recruiters.Our recruiters specialize
                in Executive Search, Diversity Search, Direct Hire, Contract and
                Contract-to-Hire talent solutions across a wide range of
                industries including IT, Accounting & Finance, Administrative &
                Office Services, Call Centers, Health care, Human Resources,
                Legal & Compliance, and Marketing & Social Media.
              </p>
            </div>
          </div>
          <hr className="my-4" />
          <div className="flex lg:flex-row flex-col gap-4 ">
            <div className="lg:w-[40%]">
              <h1 className="lg:text-4xl md:text-3xl text-xl lg:w-[80%] font-bold">
                How is our Culture ?
              </h1>
            </div>
            <div className="lg:w-[60%]">
              <p>
                A career inside Techmentee is all about working in a team
                environment where the atmosphere is dynamic, highly charged, and
                fun. You will be trained, encouraged to succeed, and groomed for
                advancement. Our work isn’t just about filling one job after
                another. It’s about taking the time to make sure we are
                listening to our candidates’ and clients’ needs, and tailoring
                our work for them — finding The Right Fit every time.And our
                hard work is balanced by all the fun we have. You’ll take part
                in annual summer outings, winter holiday parties, and birthday
                cakes every month!
              </p>
            </div>
          </div>
        </div>
        <div className="lg:p-20 md:p-10 p-5">
          <GetInTouchUs />
        </div>
      </div>
    </div>
  );
};

export default Career;
